/* Page-entry affordances only. Each designer retains editor and cart ownership. */
(function () {
  'use strict';
  if (window.JEPersonalizationEntry) { window.JEPersonalizationEntry.scan(); return; }
  const selector = '#je-birthflower-product, #je-sports-product, #je-wedding-product, #je-nurse-product, #je-groomsman-product, #je-family-product, #je-pets-product';
  const mobile = window.matchMedia('(max-width: 760px)');
  const entries = new Map();
  let frame = 0;

  function fullyVisible(button) {
    const box = button.getBoundingClientRect(), style = getComputedStyle(button);
    const viewport = window.visualViewport;
    const left = viewport?.offsetLeft || 0, top = viewport?.offsetTop || 0;
    const right = left + (viewport?.width || window.innerWidth);
    const bottom = top + (viewport?.height || window.innerHeight);
    if (!box.width || !box.height || style.visibility === 'hidden' || style.display === 'none' ||
        box.left < left || box.top < top || box.right > right || box.bottom > bottom) return false;
    // Intersection alone misses sticky headers and other overlays. Check the
    // actual hit targets, including corners, before removing the fixed action.
    return [[box.left + 4, box.top + 4], [box.right - 4, box.top + 4],
      [box.left + 4, box.bottom - 4], [box.right - 4, box.bottom - 4],
      [box.left + box.width / 2, box.top + box.height / 2]].every(([x, y]) => {
      const hit = document.elementFromPoint(x, y);
      return hit === button || button.contains(hit);
    });
  }

  function refresh() {
    frame = 0;
    for (const [root, entry] of entries) {
      if (!root.isConnected) {
        entry.resize?.disconnect(); entry.mutations?.disconnect();
        entry.dock.removeAttribute('data-entry-inline-visible'); entries.delete(root); continue;
      }
      try {
        const hide = mobile.matches && root.dataset.mobileReady === 'true' &&
          !entry.dock.contains(document.activeElement) && fullyVisible(entry.inline);
        entry.dock.toggleAttribute('data-entry-inline-visible', hide);
      } catch (_) {
        // A missing browser API or transient detached node must leave a way in.
        entry.dock.removeAttribute('data-entry-inline-visible');
      }
    }
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(refresh); }
  function scan() {
    for (const root of document.querySelectorAll(selector)) {
      const inline = root.querySelector('#open-mobile-editor-inline');
      const dock = root.querySelector('.mobile-editor-launch');
      if (!inline || !dock) continue;
      const prior = entries.get(root);
      if (prior?.inline === inline && prior.dock === dock) continue;
      prior?.resize?.disconnect(); prior?.mutations?.disconnect();
      prior?.dock.removeAttribute('data-entry-inline-visible');
      const entry = { inline, dock };
      if (window.ResizeObserver) {
        entry.resize = new ResizeObserver(schedule); entry.resize.observe(inline); entry.resize.observe(root);
      }
      if (window.MutationObserver) {
        entry.mutations = new MutationObserver(schedule);
        entry.mutations.observe(root, { attributes: true, subtree: true,
          attributeFilter: ['data-mobile-ready', 'data-mobile-editor', 'open', 'hidden', 'class', 'style'] });
      }
      entries.set(root, entry);
    }
    schedule();
  }
  window.JEPersonalizationEntry = { scan };
  function start() {
    scan();
    if (window.MutationObserver) new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('scroll', schedule, { capture: true, passive: true });
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    document.addEventListener('shopify:section:load', scan);
    document.addEventListener('shopify:section:unload', scan);
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });
    window.addEventListener('pageshow', scan);
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
